module.exports = __webpack_public_path__ + "static/media/block-3-goldcoast.61e101ae.png";